document.addEventListener('DOMContentLoaded', function () {
  // Koleksiyon açıklaması kapsayıcısı (senin temandaki sınıf)
  const desc = document.querySelector('.page-heading__content.rte.gutter-top--small');
  if (!desc) return;

  // Aynı buton iki kere eklenmesin
  if (desc.nextElementSibling && desc.nextElementSibling.classList?.contains('llz-readmore')) {
    return;
  }

  // Başlangıç: kısaltılmış (SEO için içerik DOM’da zaten var)
  desc.classList.remove('llz-expanded');
  desc.classList.add('llz-collapsed');

  // Erişilebilirlik
  if (!desc.id) desc.id = 'collection-desc';

  // Butonu oluştur
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'llz-readmore';
  btn.setAttribute('aria-controls', desc.id);
  btn.setAttribute('aria-expanded', 'false');
  btn.textContent = 'Show more';

  // Açıklamanın hemen altına yerleştir
  desc.insertAdjacentElement('afterend', btn);

  // Aç/Kapa
  btn.addEventListener('click', () => {
    // expanded sınıfını toggle et; dönüş değerinden nihai durumu al
    const isNowExpanded = desc.classList.toggle('llz-expanded');
    // expanded değilse collapsed kalsın
    desc.classList.toggle('llz-collapsed', !isNowExpanded);

    btn.setAttribute('aria-expanded', String(isNowExpanded));
    btn.textContent = isNowExpanded ? 'Show less' : 'Show more';
  });
});
